import { FormField, FormFieldSelect } from 'global/components/Form'
import { useEffect, useState } from 'react'
import { FuncoesAvaliacao, funcoesAvaliacao } from 'service/api'

interface IProps {
    required?: boolean
}

export function SelectFunction({ required }: IProps) {
    const [funcoes, setFuncoes] = useState<FuncoesAvaliacao[]>([])

    useEffect(() => {
        funcoesAvaliacao
            .get()
            .then(res => setFuncoes(res ?? []))
            .catch(() => setFuncoes([]))
    }, [])

    if (!funcoes?.length) {
        return (
            <FormField
                required={required}
                name="funcaoId"
                label="Função"
                disabled
            />
        )
    }

    return (
        <FormFieldSelect
            required={required}
            name="funcaoId"
            label="Função"
            options={funcoes.map(funcao => ({
                value: funcao.id,
                label: funcao.nome,
            }))}
        />
    )
}
